import Card from './Cards';
import grainImage from '../assets/grain.jpg';
import frondEndImageLarge from '../assets/FE_LG.png';
import frondEndImageSmallMedium from '../assets/FE_MD_SM.png';
import backEndImageLarge from '../assets/BE_LG.png';
import backEndImageSmallMedium from '../assets/BE_MD_SM.jpg';
import dataBaseImageLarge from '../assets/DB_LG.png';
import dataBaseImageSmallMedium from '../assets/DB_MD_SM.jpg';
import { ReactComponent as ReactIcon } from '../assets/react.svg';
import { ReactComponent as ReduxIcon } from '../assets/redux.svg';
import { ReactComponent as JavascriptIcon } from '../assets/Javascript.svg';
import { ReactComponent as ReduxSagaIcon } from '../assets/redux-saga.svg';
import { ReactComponent as AxiosIcon } from '../assets/Axios.svg';
import { ReactComponent as TailwindIcon } from '../assets/tailwind.svg';
import { ReactComponent as MUIIcon } from '../assets/MUI.svg';
import { ReactComponent as FormikIcon } from '../assets/Formik.svg';
import { ReactComponent as ReactRouterIcon } from '../assets/react-router.svg';
import { ReactComponent as TypeScriptIcon } from '../assets/Typescript.svg';
import { ReactComponent as HTMLIcon } from '../assets/html5.svg';
import { ReactComponent as ScssIcon } from '../assets/sass.svg';
import { ReactComponent as CssIcon } from '../assets/css.svg';
import { ReactComponent as SpringBootIcon } from '../assets/spring-boot.svg';
import { ReactComponent as javaIcon } from '../assets/java.svg';
import { ReactComponent as HibernateIcon } from '../assets/hibernate.svg';
import { ReactComponent as JDBCIcon } from '../assets/jdbc.svg';
import { ReactComponent as JPAIcon } from '../assets/jpa.svg';
import { ReactComponent as MVCIcon } from '../assets/mvc.svg';
import { ReactComponent as ThymeLeafIcon } from '../assets/Thymeleaf.svg';
import { ReactComponent as GitIcon } from '../assets/git.svg';
import { ReactComponent as FlywayIcon } from '../assets/flyway.svg';
import { ReactComponent as SpringSecurityIcon } from '../assets/Springsecurity.svg';
import { ReactComponent as SqlIcon } from '../assets/SQl.svg';
import { ReactComponent as RDBMSIcon } from '../assets/RDBMS.svg';
import { ReactComponent as PostgresIcon } from '../assets/postgres.svg';
import { ReactComponent as ScalableIcon } from '../assets/scalable.svg';

import { ToolboxItems } from './Tape';

const techStack = [
  {
    tech: 'Front End',
    title: 'Building Interfaces That Inspire',
    description: [
      {
        title: 'Crafting clean, efficient code',
      },
      { title: 'Responsive across all devices' },
      { title: 'Performance-driven and seamless UX' },
    ],
    image: {
      large: frondEndImageLarge,
      medium: frondEndImageSmallMedium,
      small: frondEndImageSmallMedium,
    },
    toolboxItems: Array(3)
      .fill([
        { title: 'React', iconType: ReactIcon },
        { title: 'Redux', iconType: ReduxIcon },
        { title: 'Java Script', iconType: JavascriptIcon },
        { title: 'Redux Saga', iconType: ReduxSagaIcon },
        { title: 'Axios', iconType: AxiosIcon },
        { title: 'Material-UI', iconType: MUIIcon },
        { title: 'Formik', iconType: FormikIcon },
        { title: 'React-Router', iconType: ReactRouterIcon },
        { title: 'TypeScript', iconType: TypeScriptIcon },
        { title: 'HTML', iconType: HTMLIcon },
        { title: 'Tailwind CSS', iconType: TailwindIcon },
        { title: 'SCSS', iconType: ScssIcon },
        { title: 'CSS', iconType: CssIcon },
      ])
      .flat(),
  },
  {
    tech: 'Back End',
    title: 'Server-Side Brilliance in Action',
    description: [
      { title: 'Robust server-side logic' },
      { title: 'Scalable and secure systems' },
      { title: 'Seamless API integration' },
    ],
    image: {
      large: backEndImageLarge,
      medium: backEndImageSmallMedium,
      small: backEndImageSmallMedium,
    },
    toolboxItems: Array(3)
      .fill([
        { title: 'Spring-Boot', iconType: SpringBootIcon },
        { title: 'Java', iconType: javaIcon },
        { title: 'Spring Security', iconType: SpringSecurityIcon },
        { title: 'Hibernate', iconType: HibernateIcon },
        { title: 'JDBC', iconType: JDBCIcon },
        { title: 'JPA', iconType: JPAIcon },
        { title: 'Spring-Boot Web MVC', iconType: MVCIcon },
        { title: 'ThymeLeaf Template Engine', iconType: ThymeLeafIcon },
        { title: 'Git', iconType: GitIcon },
        { title: 'Flyway', iconType: FlywayIcon },
      ])
      .flat(),
  },
  {
    tech: 'Data base',
    title: 'High-Performance Architecture',
    description: [
      { title: 'Scalable schema design' },
      { title: 'Clean and structured storage' },
      { title: 'Role-based permissions' },
    ],
    image: {
      large: dataBaseImageLarge,
      medium: dataBaseImageSmallMedium,
      small: dataBaseImageSmallMedium,
    },
    toolboxItems: Array(6)
      .fill([
        { title: 'SQL', iconType: SqlIcon },
        { title: 'Relational Database', iconType: RDBMSIcon },
        { title: 'PostgreSQL', iconType: PostgresIcon },
        { title: 'Scalable DB Model', iconType: ScalableIcon },
      ])
      .flat(),
  },
];

export default () => {
  return (
    <section className='pb-16 lg:py-24' id='project'>
      <div className='container'>
        {/* <SectionHeader
          eyebrow='Real-World Results'
          title='Featured Projects'
          description='See how I transfomed ideas into reality.'
        /> */}
        <div className='mt-10 md:mt-20 flex flex-col gap-20'>
          {techStack.map((tech, techIndex) => (
            <Card
              className='px-8 pt-8 sm:pb-4 md:pb-4 lg:pb-8 md:pt-12 md:px-10 lg:pt-16 lg:px-20 sticky'
              style={{
                top: `calc(64px + ${techIndex * 40}px)`,
              }}
            >
              {/* Inset shadow on all sides */}
              <div className='pointer-events-none absolute inset-0 z-20 shadow-[inset_0_0_40px_rgba(0,0,0,0.5)]'></div>

              <div
                className='absolute inset-0 -z-10 opacity-5'
                style={{
                  backgroundImage: `url(${grainImage})`,
                }}
              ></div>
              <div className='lg:grid lg:grid-cols-2 lg:gap-8 lg:pb-8 md:pb-4 sm:pb-8'>
                <div className='lg:pb-16'>
                  <div className='flex'>
                    <div className='bg-gradient-to-r from-emerald-300 to-sky-400 inline-flex font-bold uppercase tracking-widest text-sm text-transparent bg-clip-text'>
                      <span> {tech.tech}</span>
                    </div>
                  </div>
                  <h3 className='font-serif text-2xl mt-2 md:mt-5 md:text-4xl'>
                    {tech.title}
                  </h3>
                  <hr className='border-t-2 border-white/5 mt-4 md:mt-5' />
                  <ul className='flex flex-col gap-4 mt-4 md:mt-5'>
                    {tech.description.map((line) => (
                      <li className='flex gap-2 text-sm md:text-base text-white/50'>
                        <span>{line.title}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className='relative'>
                  {/* Image for large screens */}
                  <img
                    src={tech.image.large}
                    alt='Tech visual'
                    className='sm:hidden md:hidden lg:block mt-8 -mb-4 md:-mb-0 lg:absolute bottom-0 left-0 border-[2px] border-white lg:border-transparent rounded-xl lg:scale-[1.23] lg:origin-bottom-left'
                  />

                  {/* Image for medium screens */}
                  <img
                    src={tech.image.medium}
                    alt='Tech visual'
                    className='sm:hidden md:block lg:hidden mt-8 -mb-4 md:-mb-0 lg:absolute bottom-0 left-0 border-[2px] border-white lg:border-transparent rounded-xl lg:scale-[2] lg:origin-bottom-left'
                  />

                  {/* Image for small screens */}
                  <img
                    src={tech.image.small}
                    alt='Tech visual'
                    className='sm:block md:hidden lg:hidden mt-8 -mb-4 md:-mb-0 lg:absolute bottom-0 left-0 border-[2px] border-white lg:border-transparent rounded-xl lg:scale-[2] lg:origin-bottom-left'
                  />
                </div>
              </div>
              <ToolboxItems
                items={tech.toolboxItems}
                className=''
                itemsWrapperClassName='animate-move-left [animation-duration:50s]'
              />
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
